import { SVGProps } from 'react';
import SVG from '.';
import { SVGIconFilterPriceCrescent } from './SVGIconFilterPriceCrescent';
import { SVGIconFilterPriceDecrescent } from './SVGIconFilterPriceDecrescent';
import SVGIconFilterPriceEye from './SVGIconFilterPriceEye';

export default Object.assign(
  ({ children, ...rest }: SVGProps<any>) => {
    return <SVG.Icon.Filter {...rest}>{children}</SVG.Icon.Filter>;
  },
  {
    Crescent: SVGIconFilterPriceCrescent,
    Decrescent: SVGIconFilterPriceDecrescent,
    Eye: SVGIconFilterPriceEye,
  },
);
